'use client';

import { useState } from 'react';

import { IconButton } from '@/components/atoms/IconButton';
import { Text } from '@/components/atoms/Text';

import { cn } from '@/lib/utils';
import iconCloseSrc from '~/icons/x.svg';
import { SvgIcon } from '@/components/SvgIcon';

export type PopupBannerProps = {
  image: React.ReactNode;
  title: string;
  description: React.ReactNode;
  cta?: React.ReactNode;
};

export const PopupBanner = ({
  image,
  title,
  description,
  cta,
}: PopupBannerProps) => {
  const [isVisible, setIsVisible] = useState(true);

  return (
    <div
      aria-hidden={!isVisible}
      style={{
        opacity: isVisible ? 1 : 0,
        visibility: isVisible ? 'visible' : 'hidden',
      }}
      className={cn(
        'bg-base-white shadow-popup fixed bottom-6 left-6 z-[100] min-w-[320px] max-w-[600px] items-center gap-6 rounded p-6 md:flex'
      )}
    >
      <div className='flex flex-col gap-y-3'>
        <div className='flex gap-x-3'>
          {image}
          <Text variant='subtitle-l-d' classNames={{ wrapper: 'font-serif' }}>
            {title}
          </Text>
        </div>
        {description}
      </div>
      {cta}
      <IconButton
        variant='text'
        classNames={{
          root: 'absolute top-2 right-2 p-0 h-6 w-6',
          inner: 'text-gray-500 hover:text-base-black',
        }}
        size='s'
        color='secondary'
        slim
        onClick={() => setIsVisible(!isVisible)}
      >
        <SvgIcon src={iconCloseSrc} />
      </IconButton>
    </div>
  );
};
